import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class CebuanaPayoutTransactionService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getPayoutTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CebuanaPayoutTransaction/GetPayoutTransactions', data, messageService);
    }

    public downloadPayoutTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/CebuanaPayoutTransaction/DownloadPayoutTransactions', data, messageService);
    }

    public getPayoutTransactionDetail(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CebuanaPayoutTransaction/GetPayoutTransactionDetail', data, messageService);
    }

    public updatePayoutTransaction(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CebuanaPayoutTransaction/UpdatePayoutTransaction', data, messageService);
    }

    public getPayoutTransactionsSchedulerSetting(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CebuanaPayoutTransaction/GetPayoutTransactionsSchedulerSetting', data, messageService);
    }

    public updatePayoutTransactionsSchedulerSetting(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CebuanaPayoutTransaction/updatePayoutTransactionsSchedulerSetting', data, messageService);
    }

    public uploadUpdatedStatusXls(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/CebuanaPayoutTransaction/UploadTransactionStatusUpdateXls', data, messageService);
    }
}
